export default "__VITE_ASSET__c8691f6f__"